<template>
  <div class="Home">
    <solo-card id="TopCard" :card="topCard" isFull="true" />
    <card-group id="call-to-action" :options="businessUnits" :cards="[mealBoxCard,cateringCard]" />
    <card-group :tight="true" :options="bestThingMessage" :cards="[syafiqCard,shihuiCard,ernestCard,tanyaCard]" />
    <solo-card :card="delightedGroups">
      <div class="PanelContainer Customers">
        <div class="Panel--organic small-12 medium-10 large-10">
          <h3 class="typo_display_large">{{ 'home.customersHeader' | translate }}</h3>
          <div class="CustomersWrapper">
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/airbnb-c8ec71cfddc379ac0e3a37a10979ccd8f7c49e0be9743c6be47daf609f2728a4.png"
                alt="Airbnb"></div>
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/allennovery-f4827b40cd8ff0ab97a9a14dc60e26e7af43e8bfc6f0fc8187ac1c92d4dcc9af.png"
                alt="Allennovery"></div>
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/apple-935184281046c67c6068ee68369e4281b5f6e0f9e4fe74f7f57da7d876b53ae4.png"
                alt="Apple"></div>
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/appnexus-cb38e3ac2b53c824cafcbab7bdb46aa740ebd7bd501c37ed98e30e150993ec4a.png"
                alt="Appnexus"></div>
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/facebook-86021874ccaf0cd72a8c987583b0ac5cd08cbb045fc1b6ca5401e9494ea8eab8.png"
                alt="Facebook"></div>
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/microsoft-2c191d474defdd9bb81917374a5414537120d22797b1d13bfeceb34bf524ee27.png"
                alt="Microsoft"></div>
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/uber-9f5806717e271fead194722d56147257d9702fa426e83b041b3d7b9c09241c6a.png"
                alt="Uber"></div>
            <div class="CustomerWrapper small-6 medium-6 large-3 columns"><img src="/assets/customers/ubs-b72514cdf5b52cacb26f6548924cccd14c72635a6cfb5b39b5c3a0faaa54dada.png"
                alt="Ubs"></div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </solo-card>
    <!-- <card-group
      :padBottom="false"
      :cards="[healthyFood,bestInClass,changingMenu]" />
    <solo-card :card="environmentCard" /> -->
  </div>
</template>

<script>
import SoloCard from '../../page_components/SoloCard'
import CardGroup from '../../page_components/CardGroup'
import { Colors } from '../../shared/Styles'

export default {
  name: 'home',
  data: function() {
    return {
      topCard: {
        size: 'full',
        isFluid: true,
        contentStyle: {
          maxWidth: '460px',
          position: 'absolute',
          top: '50%',
          left: 0,
          right: 0,
          padding: '1.5rem 1rem',
          transform: 'translateY(-50%)'
        },
        backgroundImage: `url(${require('./images/Landing_Group.jpg')})`,
        backgroundPosition: 'center top',
        header: {
          text: 'home.bannerHeader',
          class: 'typo_display_x_large',
          style: {
            ...Colors.light,
            marginBottom: '0.5rem',
            textShadow: '0 2px 6px rgba(0, 0, 0, 0.5)'
          }
        },
        subHeader: {
          text: 'home.bannerSubheader',
          class: 'typo_display_light',
          style: {
            ...Colors.light,
            backgroundImage: 'linear-gradient(to right, #f6703e 33%, rgba(255,255,255,0) 0%)',
            backgroundPosition: 'left bottom',
            backgroundSize: '250px 4px',
            backgroundRepeat: 'no-repeat',
            paddingBottom: '1rem',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)'
          }
        }
      },
      sherrsLine: {
        backgroundImage: `url(${require('./images/Product_MealBox.jpg')})`
      },
      mealBoxCard: {
        size: 'half',
        isFluid: true,
        backgroundColor: '#f7f7f7',
        height: {
          sm: 'initial',
          md: 'initial',
          lg: 'initial'
        },
        contentStyle: {
          width: 'calc(100% + 1.5rem)',
          padding: '5rem 0',
          margin: 'auto -.75rem',
          sm: {
            padding: '3rem 0'
          }
        },
        header: {
          text: 'businessUnit.onlineRestaurant',
          class: 'typo_display_large',
          style: { ...Colors.brand, marginBottom: '0.5rem' }
        },
        subHeader: {
          text: 'home.onlineRestaurantCopy',
          style: { ...Colors.dark, maxWidth: '460px', margin: '0 auto 0.5rem' }
        },
        image: {
          url: require('./images/Landing_Product_OnlineRestaurant.jpg'),
          style: {
            width: 'calc(100% - 1.5rem)'
          }
        },
        button: {
          text: 'home.onlineRestaurantCTA',
          class: 'typo_display_light',
          style: {
          },
          url: '/eat'
        }
      },
      cateringCard: {
        size: 'half',
        isFluid: true,
        backgroundColor: '#f7f7f7',
        height: {
          sm: 'initial',
          md: 'initial',
          lg: 'initial'
        },
        contentStyle: {
          width: 'calc(100% + 1.5rem)',
          padding: '5rem 0',
          margin: 'auto -.75rem',
          sm: {
            padding: '3rem 0'
          }
        },
        header: {
          text: 'businessUnit.catering',
          class: 'typo_display_large',
          style: { ...Colors.brand, marginBottom: '0.5rem' }
        },
        subHeader: {
          text: 'home.cateringCardCopy',
          style: { ...Colors.dark, maxWidth: '460px', margin: '0 auto 0.5rem' }
        },
        image: {
          url: require('./images/Landing_Product_Catering.jpg'),
          style: {
            width: 'calc(100% - 1.5rem)'
          }
        },
        button: {
          text: 'home.cateringCTA',
          class: 'typo_display_light',
          style: {
          },
          url: '/catering'
        }
      },
      businessUnits: {
        style: {
          maxWidth: '100%'
        }
      },
      bestThingMessage: {
        hasMessage: true,
        style: {
          maxWidth: '100%'
        },
        header: {
          text: "home.bestThing",
          style: {
            ...Colors.light,
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '2rem',
            lineHeight: '3rem'
          }
        }
      },
      delightedGroups: {
        size: 'full',
        isFluid: true,
        backgroundColor: '#f7f7f7',
        contentStyle: {
          width: '100%',
          margin: '5rem 0',
          padding: '0',
          display: 'flex',
          sm: {
            margin: '3rem 0'
          }
        },
        height: {
          sm: 'initial',
          md: '490px',
          lg: 'initial'
        }
      },
      healthyFood: {
        size: 'third',
        contentStyle: {
          width: '100%',
          marginBottom: '1rem',
          padding: '1rem',
          lineHeight: '1.25rem',
          background: '#FFF'
        },
        height: {
          sm: '500px',
          md: '490px',
          lg: '580px'
        },
        backgroundImage: `url(${require('./images/HealthyAndTasty.jpg')})`,
        backgroundPosition: 'top',
        backgroundSize: '100%',
        label: {
          text: `home.healthyFoodHeader`,
          style: { ...Colors.brand
          }
        },
        padding: '0',
        subHeader: {
          text: 'home.healthyFoodSubheader',
          style: { ...Colors.dark,
            maxWidth: '80%',
            margin: 'auto'
          }
        }
      },
      bestInClass: {
        size: 'third',
        contentStyle: {
          width: '100%',
          marginBottom: '1rem',
          padding: '1rem',
          lineHeight: '1.25rem',
          background: '#FFF'
        },
        height: {
          sm: '500px',
          md: '490px',
          lg: '580px'
        },
        backgroundImage: `url(${require('./images/BestInClass.jpg')})`,
        backgroundPosition: 'top',
        backgroundSize: '100%',
        label: {
          text: 'home.bestInClassHeader',
          style: { ...Colors.brand
          }
        },
        padding: '0',
        subHeader: {
          text: 'home.bestInClassSubheader',
          style: { ...Colors.dark,
            maxWidth: '80%',
            margin: 'auto'
          }
        }
      },
      changingMenu: {
        size: 'third',
        contentStyle: {
          width: '100%',
          marginBottom: '1rem',
          padding: '1rem',
          lineHeight: '1.25rem',
          background: '#FFF'
        },
        height: {
          sm: '500px',
          md: '490px',
          lg: '580px'
        },
        padding: '0',
        backgroundImage: `url(${require('./images/InHouseChef.jpg')})`,
        backgroundPosition: 'top',
        backgroundSize: '100%',
        label: {
          text: 'home.changingMenuHeader',
          style: { ...Colors.brand
          }
        },
        subHeader: {
          text: 'home.changingMenuSubheader',
          style: { ...Colors.dark,
            maxWidth: '80%',
            margin: 'auto'
          }
        }
      },
      syafiqCard: {
        size: 'quarter',
        backgroundImage: `url(${require('./images/Landing_WorkingProfessional.jpg')})`,
        backgroundPosition: 'center 25%',
        height: {
          sm: '400px',
          md: '490px',
          lg: '480px'
        }
      },
      shihuiCard: {
        size: 'quarter',
        backgroundImage: `url(${require('./images/Landing_YoungGirl.jpg')})`,
        backgroundPosition: 'center 25%',
        height: {
          sm: '400px',
          md: '490px',
          lg: '480px'
        }
      },
      ernestCard: {
        size: 'quarter',
        backgroundImage: `url(${require('./images/Landing_TechGeek.jpg')})`,
        backgroundPosition: 'center 25%',
        height: {
          sm: '400px',
          md: '490px',
          lg: '480px'
        }
      },
      tanyaCard: {
        size: 'quarter',
        backgroundImage: `url(${require('./images/Landing_OfficeExecutive.jpg')})`,
        backgroundPosition: 'center 25%',
        height: {
          sm: '400px',
          md: '490px',
          lg: '480px'
        }
      },
      environmentCard: {
        size: 'full',
        contentStyle: {
          width: '100%',
          paddingTop: '2rem',
          textAlign: 'center'
        },
        backgroundImage: `url(${require('./images/CareForMotherEarth.jpg')})`,
        backgroundPosition: 'bottom',
        label: {
          text: 'home.motherEarthHeader',
          style: { ...Colors.light,
            textAlign: 'center',
            marginTop: '2rem 0 1rem'
          }
        },
        subHeader: {
          text: 'home.motherEarthSubheader',
          style: { ...Colors.light,
            textAlign: 'center',
            maxWidth: '420px',
            margin: '1rem auto'
          }
        }
      }
    }
  },
  components: {
    SoloCard,
    CardGroup
  }
}
</script>

<style lang="scss">
@import '../../../assets/stylesheets/_shared_variables.sass';
@import '../../../assets/stylesheets/_global_styles.scss';

body .container {
  background: #FFFFFF
}
</style>

<style lang="scss" scoped>
@import '../../../assets/stylesheets/_shared_variables.sass';
.Home {
  /deep/ #TopCard {
    .CardWrap {
      height: 850px !important;

      @media only screen and (max-width: 1600px) {
        height: 592px !important;
      }
      @media only screen and (max-width: 960px) {
        height: 550px !important;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: linear-gradient(transparent, transparent 30%, rgba(0,0,0,0.5));
        }
      }
      @media only screen and (max-width: 640px) {
        height: 400px !important;
      }
    }
    .contentBox {
      @media only screen and (max-width: 960px) {
        top: auto !important;
        transform: none !important;
        bottom: 0;
      }
      @media only screen and (min-width: 641px) and (max-width: 960px) {
        padding-bottom: $space-xxl !important;
      }
      @media only screen and (max-width: 640px) {
        padding-bottom: $space-xl !important;
      }
    }
  }
}
</style>
